import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import AppModel from '../DataModel/AppModel';
import AppModelUtils from '../DataModel/AppModelUtils';
import PageLoading from '../components/PageLoading';
import RaisedButton from 'material-ui/RaisedButton';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import * as TimeFormatter from '../utils/TimeFormatter';

import {Table, TableBody, TableRow, TableRowColumn} from 'material-ui/Table';
import {Toolbar, ToolbarGroup} from 'material-ui/Toolbar';

const style = {
  height: 100,
  margin: 40,
  padding: 20,
  textAlign: 'center',
  display: 'inline-block',
};

const pageStyle = {
  margin: "1em",
};

const headerStyle = {
  marginLeft: "1em",
  marginTop: "1em",
  fontFamily: "Roboto, sans-serif",
  fontSize: "20px",
  fontWeight: "400",
  height: "48px",
  lineHeight: "48px"
}


export default @observer

class JobPage extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }
  state = {
    open: false,
  };
  stopProcess(job) {
    // Request machine to stop ongoing process
    const self = this;
    return function () {
      AppModelUtils.stop_process(job);
      self.setState({ open: false })
    }
  }
  resendEmailReport(job) {
    // Request the report for this job to be resent by email to the logged
    // in user
    return function () {
      AppModelUtils.requestPDFReportResend(job);
    }
  }

  showGraphDialogue(job) {
    // We trigger the display of the fullscreen graph popup.
    var self = this;
    return function () {
      var job_time = +job.start_time;
      self.context.router.push(`/jobs/job/${encodeURI(job.id_machine)}/${job_time}/graph`);
    }
  }

  averageReadings(job) {
    var rows = [];
    var iterations = 0;
    if (job == null) return rows;

    if (job.avg_h202_for_all_sensors) {
      for (let sensor of job.avg_h202_for_all_sensors) {
        if (sensor && sensor.avgValue !== null) {
          rows.push({
            name: uiMsg('JB_AVG_H2O2', "Average H<sub>2</sub>O<sub>2</sub>"),
            key: iterations++,
            sensorIndex: sensor.index,
            sensorName: sensor.name,
            value: (+sensor.avgValue).toFixed(1),
            unit: "ppm"
          });
        }
      }
    }

    if ((job.recentlyActive || job.running) && job.last_h2o2_for_all_sensors) {
      for (let sensor of job.last_h2o2_for_all_sensors) {
        if (sensor && sensor.value !== null) {
          rows.push({
            name: uiMsg('JP_CURR_H2O2', "Current H<sub>2</sub>O<sub>2</sub>"),
            key: iterations++,
            sensorIndex: sensor.index,
            sensorName: sensor.name,
            value: sensor.value.toFixed(1),
            unit: "ppm"
          });
        }
      }
    }

    return rows;
  }

  isStopProcessSupported(job) {
    if (job == null) return false;
    return job.supported_features && job.supported_features.includes("STOP_PROCESS");
  }

  alarmsView(job) {
    if (!job.alarms || job.alarms.length == 0) return null;
    return (
      <span>
        <h2 style={headerStyle}>{uiMsg('JP_ALARMS_DURING', "<X> alarm(s) during job", job.alarms.length)}</h2>
        <Table>
          <TableBody displayRowCheckbox={false}>
                    subtitle={uiMsg('JP_ALARMS_REGISTERED_DURING', "<X> alarm(s) registered during job", job.alarms.length)} />
            {job.alarms.map((a, i) => (
                <TableRow key={"alarm" + i}>
                  <TableRowColumn style={{width: '3em'}}>{TimeFormatter.timeStr(a.ts)}</TableRowColumn>
                  <TableRowColumn style={{whiteSpace: 'normal'}}>{a.description}</TableRowColumn>
                  <TableRowColumn style={{whiteSpace: 'normal'}}>{a.msg}</TableRowColumn>
                </TableRow>
              )
            )}
          </TableBody>
        </Table>
      </span>
    );
  }

 extraLocationInfo( section, building) {
  var extraLocationInfo = [];
  if(building || section) {    
    if(section) {
      extraLocationInfo.push(section);
    }
    if(building && section) {
      extraLocationInfo.push(",");
    }
    if(building) {
      extraLocationInfo.push(building);
    }
  }
  return extraLocationInfo.join("");
 }

  render() {
    var job = AppModel.currentJob;
    var averageReadingsToDisplay = this.averageReadings(job);
    var isStopProcessSupported = this.isStopProcessSupported(job);

    const actions = [
      <FlatButton
        label={uiMsg('JP_B_CANCEL', "Cancel")}
        primary={true}
        keyboardFocused={true}
        onClick={() => this.setState({open: false})}
      />,
      <FlatButton
        label={uiMsg('JP_B_YES', "YES")}
        primary={true}
        onClick={this.stopProcess(job).bind(this)}
      />,
    ];

    if (!job) return <PageLoading loading={AppModel.fetchingJobDetails}/>;
    return (
      <div style={pageStyle}>
        <PageLoading loading={AppModel.fetchingJobDetails || AppModel.requestingEmailReport}>
          <h2 style={headerStyle}>{uiMsg('JP_ROOM', "Room")}: {job.location_name} {this.extraLocationInfo(job.section, job.building)}</h2>
          <Table>
            <TableBody displayRowCheckbox={false}>
              <TableRow>
                <TableRowColumn>{uiMsg('JP_VOLUME', "Volume")}:</TableRowColumn>
                <TableRowColumn>{job.volume_m3 ? job.volume_m3.toFixed(1) : "?"} m<sup>3</sup></TableRowColumn>
              </TableRow>
              <TableRow>
                <TableRowColumn>{uiMsg('JP_MACHINE', "Machine")}:</TableRowColumn>
                <TableRowColumn style={{whiteSpace: 'normal'}}>{job.machine_name || job.id_machine}</TableRowColumn>
              </TableRow>
              {job.fluid ?
                <TableRow>
                  <TableRowColumn>{uiMsg('JP_FLUID', "Fluid")}:</TableRowColumn>
                  <TableRowColumn style={{whiteSpace: 'normal'}}>{job.fluid}</TableRowColumn>
                </TableRow> : null}
              {job.fluid_id ?
                <TableRow>
                  <TableRowColumn>{uiMsg('JP_FLUID_ID', "Fluid id")}:</TableRowColumn>
                  <TableRowColumn style={{whiteSpace: 'normal'}}>{job.fluid_id}</TableRowColumn>
                </TableRow> : null}
              <TableRow>
                <TableRowColumn>{uiMsg('JP_OPERATOR', "Operator")}:</TableRowColumn>
                <TableRowColumn>{job.user_id}</TableRowColumn>
              </TableRow>
              <TableRow>
                <TableRowColumn>{uiMsg('JP_JOB_TYPE', "Disinfection type")}:</TableRowColumn>
                <TableRowColumn style={{whiteSpace: 'normal'}}><span dangerouslySetInnerHTML={{__html:uiMsg(`JOB_TYPE_DESC_${job.job_type_id}`, job.job_type_name || job.job_type_id)}}></span></TableRowColumn>
              </TableRow>
              <TableRow>
                <TableRowColumn>{uiMsg('JP_JOB_STARTED', "Job started")}:</TableRowColumn>
                <TableRowColumn style={{whiteSpace: 'normal'}}>
                  {TimeFormatter.dateAndTime(job.start_time)}</TableRowColumn>
              </TableRow>
              {job.end_time ? /* Only display this row if job has ended */
                <TableRow>
                  <TableRowColumn>{uiMsg('JP_JOB_ENDED', "Job ended")}:</TableRowColumn>
                  <TableRowColumn style={{whiteSpace: 'normal'}}>
                    {TimeFormatter.dateAndTime(job.end_time)}</TableRowColumn>
                </TableRow>
                : null}
              <TableRow>
                <TableRowColumn>{uiMsg('JP_RESULT', "Result")}:</TableRowColumn>
                <TableRowColumn style={{whiteSpace: 'normal'}}>{job.statusMsg}</TableRowColumn>
              </TableRow>
              {averageReadingsToDisplay.map(ard =>
                <TableRow key={ard.key}>
                  <TableRowColumn style={{whiteSpace: 'normal'}}> {/* To support subscript in h2o2 names:*/}
                    <span dangerouslySetInnerHTML={{__html: ard.name}}/>
                    <span> ({ard.sensorName}) </span>
                  </TableRowColumn>
                  <TableRowColumn>{ard.value} {ard.unit}
                  </TableRowColumn></TableRow>
              )}
            </TableBody>
          </Table>
          <Toolbar>
            <ToolbarGroup firstChild={true}>
              <RaisedButton label={uiMsg('JP_B_SEE_GRAPH', "See graph")}
                            onTouchTap={this.showGraphDialogue(job).bind(this)}
                            primary={true}/>
              {!!job.end_time ?
                <RaisedButton label={uiMsg('JP_B_RESEND_PDF', "Resend PDF report (email)")}
                              onTouchTap={this.resendEmailReport(job).bind(this)}
                              primary={true}/>
                : ""}
              { isStopProcessSupported && !job.end_time && job.machine_action !== 'STOP' && (job.user_id === AppModel.id_user || AppModel.permissions.indexOf("CTRL_REMOTE_JOB") !== -1) ?
                <RaisedButton label={uiMsg('JP_B_STOP_PROCESS', "Stop process")}
                              onTouchTap={() => this.setState({ open: true })}
                              primary={true}/>
                : ""}
              { isStopProcessSupported && !job.end_time && job.machine_action === 'STOP' && (job.user_id === AppModel.id_user || AppModel.permissions.indexOf("CTRL_REMOTE_JOB") !== -1) ?
                <FlatButton
                              style={{cursor:'wait'}}
                              primary={true}
                              label={uiMsg('JP_B_STOPPING_PROCESS', "Stopping process")}
                            />
                : ""}
            </ToolbarGroup>
          </Toolbar>
          {this.alarmsView(job)}
          <Dialog
            title={uiMsg('JP_B_STOP_PROCESS', "Stop process")}
            actions={actions}
            modal={false}
            open={this.state.open}
            onRequestClose={() => this.setState({ open: false })}
          >
            {uiMsg('JP_STOP_PROCESS_CONFIRMATION', "Are you sure you want to stop the process?")}
          </Dialog>
        </PageLoading>
      </div>
    );
  }
};



/** WEBPACK FOOTER **
 ** ./src/pages/JobPage.jsx
 **/